import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // eslint-disable-line no-unused-vars
import fire from '../firebase/firebase';
import PhoneNumber from 'react-phone-number';

class NavItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: null,
     };
  }

  componentDidMount() {
    let phoneNumber = fire.database().ref('phone-number');
    phoneNumber.on('value', snapshot => {
      this.setState({phoneNumber: snapshot.val()});
    });
  }
  render() {
    const {closeMenu} = this.props;
    return (
    <div>
        <li><Link onClick={closeMenu} to="/solutions">Solutions<span className="eitx-orange">.</span></Link></li>
        <li><Link onClick={closeMenu} to="/ourteam">About us<span className="eitx-orange">.</span></Link></li>
        <li><Link onClick={closeMenu} to="/casestudies">Case Studies<span className="eitx-orange">.</span></Link></li>
        <li><Link onClick={closeMenu} to="/careers">Careers<span className="eitx-orange">.</span></Link></li>
        <li className="app-nav-side-borders app-nav-wider"><a href="#contact" onClick={closeMenu}>Contact Us<span className="eitx-orange">.</span></a></li>
        <li className="app-nav-wider no-border"><PhoneNumber number={this.state.phoneNumber} isLinked={true} /></li>
    </div>
    )
  }
}

export default NavItems



// WEBPACK FOOTER //
// ./src/shared/nav-items.js